import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { MetadataTag, MetadataTagToUpdate } from "../types";

export const updateMetadataTag = async (
  metadataTagId: string,
  metadataTag: MetadataTagToUpdate,
): Promise<MetadataTag> => {
  const metadataTagDocRef = doc(db, "metadataTags", metadataTagId);

  try {
    await updateDoc(metadataTagDocRef, metadataTag);
    const updatedTagSnapshot = await getDoc(metadataTagDocRef);
    return updatedTagSnapshot.data() as MetadataTag;
  } catch (error) {
    console.error("Failed to update the metadata tag:", error);
    throw error; // Rethrow or handle as needed
  }
};
